export const BLOG_PAGE_ID = 'blog';
export const BLOG_POST_PAGE_ID = 'post';
export const BLOG_WIDGET_ID = 'blog_header_widget';
export const MEMBERS_PAGE_ID = 'members';
export const MEMBER_DRAFTS_ID = 'member-drafts-page';
export const SEARCH_RESULTS_ID = 'search-results';
//# sourceMappingURL=component-ids.js.map